import axios from "axios";
import { base_url } from "../../utils/baseUrl";



const getDMCs = async () => {

    const response = await axios.get(`${base_url}dmc/getAllDMCs`);

    return response.data;

};
const createDMC = async (values) => {
    const response = await axios.post(`${base_url}dmc/addDMC`, values);

    return response.data;
};

const updateDMC = async (values) => {
    const id = values.id
    const response = await axios.put(
        `${base_url}dmc/editDMC/${id}`,
        values,

    );

    return response.data;
};
const updateDMCStatus = async (values) => {
    console.log(values, "status")
    const id = values.id
    const response = await axios.put(
        `${base_url}dmc/approve-supplier/${id}`,
        values,
        {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            },
        }

    );

    return response.data;
};

const getDMC = async (id) => {
    const response = await axios.get(`${base_url}dmc/getById/${id}`);
    return response.data;
};

const deleteDMC = async (id) => {
    const response = await axios.delete(`${base_url}dmc/deleteDMC/${id}`);

    return response.data;
};
const DMCService = {
    getDMCs,
    createDMC,
    getDMC,
    updateDMC,
    updateDMCStatus,
    deleteDMC,
};

export default DMCService;
